import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="lightgreencontentbg keyquestionpad">


                                                <ol className="testclass_numeric"
                                                    style={{counterReset: 'item 1'}}>
                                                    <li><p className="further_info_content"><span
                                                        className="green"><strong>Openness to experience</strong></span>
                                                    </p></li>
                                                </ol>


                                                <p className="further_info_content pad-sept"><span
                                                    className="pad-bot">Are you more</span></p>

                                                <p><span className="green"
                                                         style={{paddingRight:'10px'}}><strong>a)</strong> </span> interested
                                                    in new experiences, ways of doing things, and ideas?</p>


                                                <div style={{paddingBottom: '13px'}}><span
                                                    className="subtiltereg1"
                                                    style={{paddingTop:'10px'}}>OR</span></div>
                                                <div className="uiheading">
                                                    <p><span className="green"
                                                             style={{paddingRight:'10px'}}><strong>b)</strong> </span> prefer
                                                        more established ways of doing things – ‘hands on’,
                                                        more practical?</p>


                                                </div>

                                            </div>

                                            <p><span
                                                className="subtiltereg">Openness decision making style</span>
                                            </p>
                                            <p>If you answered (a) you may have a preference for a decision
                                                making style that centres on
                                                creativity. This is where you can develop creative solutions
                                                to a problem. It is a freewheeling way
                                                of thinking, in which there is little criticism of ideas. A
                                                whole range of creativity tools can help you
                                                here. You may risk being overly focused on new ideas and
                                                ways of doing things rather than
                                                making the decision itself and you may delay this stage.</p>
                                            <p>If you answered (b) your preferred decision making style may
                                                be to focus on the data available.
                                                You look at the information you have, and see what you can
                                                learn from it. You look for gaps in your
                                                knowledge, and either try to fill them or take account of
                                                them. This is where you analyse past
                                                trends, and try to extrapolate from historical data. You
                                                could benefit from ensuring that you take
                                                yourself away from the data at times to consider new ways of
                                                doing things.</p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <ol className="testclass_numeric"
                                                    style={{counterReset: 'item 2'}}>
                                                    <li><p className="further_info_content"><span
                                                        className="green"><strong>Conscientiousness</strong></span>
                                                    </p></li>
                                                </ol>

                                                <p className="further_info_content pad-sept"><span
                                                    className="pad-bot">Which is more like you</span></p>

                                                <p><span className="green"
                                                         style={{paddingRight:'10px'}}><strong>a)</strong> </span> Organised,
                                                    conscientious, compliant and someone who pays attention
                                                    to the details?</p>


                                                <div style={{paddingBottom: '13px'}}><span
                                                    className="subtiltereg1">OR</span></div>

                                                <p><span className="green"
                                                         style={{paddingRight:'10px'}}><strong>b)</strong> </span> Chaotic,
                                                    unplanned, spontaneous – a risk taker?</p>


                                            </div>

                                            <p><span className="subtiltereg">Decision making style</span>
                                            </p>

                                            <p>If you answered (a) you are likely to have a planned decision
                                                making style when making important
                                                or complicated decisions. In other words, you gather
                                                information and apply a systematic and
                                                deliberate approach that is a balance between logical
                                                reasoning and intuition. A planned approach
                                                takes time and energy but is worthwhile when you have to
                                                make important decisions. You will also
                                                be more confident with your decision if you know you have
                                                done your homework and it feels right
                                                intuitively. You run the risk of needing all of the
                                                information to make a decision and you may not
                                                be overly comfortable with ambiguity.</p>
                                            <p>If you answered (b) you may have a more spontaneous style of
                                                decision making – gathering some
                                                information but feeling comfortable and ready to act even
                                                when and as soon as you have difficult
                                                information. You will be unafraid of taking risks, having to
                                                change strategies at short notice, or
                                                amending your decisions in light of new information. You
                                                need to ensure that you consider all of
                                                the evidence that you have, or need, in order to make the
                                                most informed decision.</p>
                                            <div className="lightgreencontentbg keyquestionpad">


                                                <ol className="testclass_numeric"
                                                    style={{counterReset: 'item 3'}}>
                                                    <li><p className="further_info_content"><span
                                                        className="green"><strong>Agreeableness</strong></span>
                                                    </p></li>
                                                </ol>

                                                <p className="further_info_content pad-sept"><span
                                                    className="pad-bot">Are you</span></p>
                                                <p><span className="green"
                                                         style={{paddingRight:'10px'}}><strong>a)</strong> </span> Focused
                                                    on people, maintaining harmonious relationships,
                                                    concerned with the emotional needs of others?</p>


                                                <div style={{paddingBottom: '13px'}}><span
                                                    className="subtiltereg1">OR</span></div>

                                                <p><span className="green"
                                                         style={{paddingRight:'10px'}}><strong>b)</strong> </span> Focused
                                                    on the task, what needs to be done, speak your mind?</p>

                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}